import { z } from 'zod';

export const WEB_EXPOSE_REQUEST_KINDS = ['INQUIRY', 'FULL_EXPOSE'] as const;
export type WebExposeRequestKind = (typeof WEB_EXPOSE_REQUEST_KINDS)[number];

// Mirrors SubmitWebsiteInquiryBodySchema's tolerance on purpose: the intake names every missing field in one 422.
export const SubmitWebExposeInquiryBodySchema = z
  .object({
    kind: z.enum(WEB_EXPOSE_REQUEST_KINDS),
    firstName: z.string().max(150).nullable().optional(),
    lastName: z.string().max(150).nullable().optional(),
    email: z.string().max(320).nullable().optional(),
    phone: z.string().max(100).nullable().optional(),
    message: z.string().nullable().optional(),
    // The form cannot send without the tick; a request without it is not a submission.
    privacyAccepted: z.literal(true),
    homepage: z.string().max(2000).nullable().optional(),
  })
  .strict();
export type SubmitWebExposeInquiryBody = z.infer<typeof SubmitWebExposeInquiryBodySchema>;
